__webpack_require__.p = "/blue/";